import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-heading font-bold text-lg">
                漫
              </span>
              <span className="font-heading font-bold text-xl text-background-50 whitespace-nowrap">
                韩漫屋
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              韩漫屋-好看的韩国漫画免费阅读平台。每日更新海量热门韩漫，涵盖恋爱、奇幻、动作、悬疑等多种类型，为您提供优质的漫画阅读体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-100 mb-4">
              <a href="/category/all" className="hover:text-primary-400 transition-colors">漫画分类</a>
            </h4>
            <ul className="space-y-2">
              {categories.filter((c) => c.id !== 'all').map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-100 mb-4">
              <a href="#" className="hover:text-primary-400 transition-colors">快速链接</a>
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors">首页</Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-background-400 hover:text-background-100 transition-colors">全部漫画</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors">关于我们</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-100 mb-4">
              <a href="/about" className="hover:text-primary-400 transition-colors">联系我们</a>
            </h4>
            <ul className="space-y-2 text-sm text-background-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>hello@nheap.cn</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-2-line"></i>
                <span>在线客服：工作日 9:00-18:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 韩漫屋 nheap.cn - 好看的韩国漫画免费阅读平台
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all"
              rel="nofollow"
              aria-label="微博"
            >
              <i className="ri-links-line"></i>
            </a>
            <a
              href="#"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all"
              rel="nofollow"
              aria-label="微信"
            >
              <i className="ri-wechat-line"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
